import React, { useEffect, useState } from "react";
import { Grid, Typography, Select, MenuItem } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "@material-ui/lab/Skeleton";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import { updateMeterDetails } from "../../../../actions/home.action";
import ExpandMoreSharpIcon from "@material-ui/icons/ExpandMoreSharp";
import EAccount_SA_Switched_Warning from "../../../e_account_sa_switch_warning/e_account-sa-switched-warning";
import { useTranslation } from "react-i18next";
import { commonService } from "../../../../services";
const useStyle = makeStyles((theme) => ({
  blueTextColor: {
    color: theme.palette.ePrimary?.base,
    lineHeight:1.2
  },
}));
export default function YourAccounts() {
  const FATHERNAME='fatherName';
  const SPOUSENAME='spouseName';
  const TARRIF='tariff';
  let classes = useStyle();
  let dispatch = useDispatch();
  let [connectionStatus, setconnectionStatus] = useState(null);
  let [premiseDetail, setPremiseDetails] = useState(null);
  let [connection,setConnection]=useState("")
  let [serviceAgreement,setServiceAgreement]=useState(null)
  let [showWarning,setShowWarning]=useState(false)
  let [openDialog,setOpenDialog]=useState(false)
  const [nidNumber,setnidNumber]=useState()
  const [cNo,setCno] = useState()
  const [fName,setFname] = useState()
  const [sName,setSname] = useState()
  const [tarrif,setTarrif]=useState()
  const [noc,setNoc] = useState();
  const {t:label, ready: profieLabelReady} = useTranslation("label-E_CUSTOMER_PROFILE");
  const {t:labels, ready: customerLabelReady} = useTranslation("label-NESCO_Customer_No_label")

  let primaryIdentifier = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.PRIMARY_IDENTIFIER
  );
  let meterDetails = useSelector((state) => state?.meterDetails);
  let accountInformation = useSelector((state) => state?.accountInformation?.personDetailList);
  let saId = useSelector((state) => state?.meterDetails?.getSaInfo?.saId);
  let dateFormat = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_DATE_MONTH_YEAR_FORMAT
  );
  let accountDetails = useSelector(
    (state) =>
      state?.accountInformation?.personAcccountDetail?.personAccountList
  );
  let premiseDetails=meterDetails?.accountPersonDetail?.accountPremiseDetailList
  let meterSerialNumber =premiseDetails? Array.isArray(premiseDetails)?
  premiseDetails?.find(meterList=>meterList.saId==saId)?.meterDetailsList?.serial
 : premiseDetails?.meterDetailsList?.serial :""
  useEffect(()=>{
    if(saId){
      setConnection(saId)
    }
  },[saId])


  useEffect(()=>{
    let meterSerialNumber =premiseDetails? Array.isArray(premiseDetails)?
  premiseDetails?.find(meterList=>meterList.saId==saId): premiseDetails :"";
  if(meterSerialNumber['nocsOffice']){
    setNoc(meterSerialNumber['nocsOffice'])
  }else{
    setNoc("-")
  }
  },[cNo,saId])

  useEffect(()=>{
    setCno(meterDetails?.[primaryIdentifier])
  },[meterDetails])

  const ddlMenuProps = {
    disableScrollLock: false,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right",
    },
    getContentAnchorEl: null,
  };

  const handleBeforeUnload=(e)=>{
    e.preventDefault()
    e.returnValue = '';
  }

  // useEffect(()=>{
  //   window.addEventListener("beforeunload", handleBeforeUnload,{capture:true}); 
  //   return () =>{
  //      window.removeEventListener("beforeunload", handleBeforeUnload,{capture:true})
  //      }
  // },[])

  const updateDetails=()=>{
    setOpenDialog(false)
    setServiceAgreement(null)
    accountDetails &&
    accountDetails.map((item) => {
      return (
        <div>
          {meterDetails?.[primaryIdentifier] === item?.[primaryIdentifier] &&
            meterDetails?.accountSaList.map((saItem) => {
              return (
                saItem?.saId === connection &&
                 dispatch(updateMeterDetails(item, saItem))
              );
            })}
        </div>
      );
    });
  }

  useEffect(()=>{
    let fName=''
      if(accountDetails){
        accountDetails.map(e=>{
            if(e.customerNumber ==cNo){
              if(FATHERNAME in e  && e[FATHERNAME]!='NULL' ){
                setFname(e[FATHERNAME])
              }else{
                setFname("-")
              }
              if(SPOUSENAME in e && e[SPOUSENAME]!='NULL'){
                setSname(e[SPOUSENAME])
              }else{
                setSname("-")
              }
              if(TARRIF in e){
                setTarrif(e[TARRIF])
              }
            }
          })
          
      }
  },[cNo])

  const sameDetails=()=>{
    setOpenDialog(false)
    setConnection(serviceAgreement)
    setServiceAgreement(null)
  }

  const handleChange = (e) => {
                setServiceAgreement(meterDetails?.getSaInfo?.saId)
                setConnection(e.target.value);
                setShowWarning(true)
                setOpenDialog(true)
  };
  useEffect(() => {
    if (meterDetails && connectionStatus === null) {
      if (Number(meterDetails?.getSaInfo?.saStatus) == 20) {
        setconnectionStatus("E_ACTIVE")
      } else if (Number(meterDetails?.getSaInfo?.saStatus) == 10) {
        setconnectionStatus("E_PENDING_START");
      } else if (Number(meterDetails?.getSaInfo?.saStatus) == 30) {
        setconnectionStatus("E_PENDING_STOP");
      } else if (Number(meterDetails?.getSaInfo?.saStatus) == 40) {
        setconnectionStatus("E_STOPPED");
      } else if (Number(meterDetails?.getSaInfo?.saStatus) == 50) {
        setconnectionStatus("E_REACTIVE");
      } else if (Number(meterDetails?.getSaInfo?.saStatus) == 60) {
        setconnectionStatus("E_CLOSED");
      } else if (Number(meterDetails?.getSaInfo?.saStatus) == 70) {
        setconnectionStatus("E_CANCELED");
      } else {
        setconnectionStatus("E_NA");
      }
    }
  }, [meterDetails]);

  useEffect(() => {
    let premise =
      meterDetails?.accountPersonDetail?.accountPremiseDetailList?.length > 1
        ? meterDetails?.accountPersonDetail?.accountPremiseDetailList[0]
        : meterDetails?.accountPersonDetail?.accountPremiseDetailList;
    if (premise) {
      let address =
        premise?.address1 && premise?.address2 && premise?.address3
          ? premise?.address1 +
            ", " +
            premise?.address2 +
            ", " +
            premise?.address3
          : premise?.address1 && premise?.address2
          ? premise?.address1 + ", " + premise?.address2
          : premise?.address1 && premise?.address3
          ? premise?.address1 + ", " + premise?.address3
          : premise?.address2 && premise?.address3
          ? premise?.address2 + ", " + premise?.address3
          : premise?.address1
          ? premise?.address1
          : premise?.address2
          ? premise?.address2
          : premise?.address3
          ? premise?.address3
          : null;
      let premiseAdd =
        (premise?.city && ", " + premise?.city) +
        (premise?.postal && ", " + premise?.postal)
      setPremiseDetails(address + premiseAdd);
    }
    if(Array.isArray(accountInformation["C1-Person"]?.personIdentifier)){
      let account = accountInformation["C1-Person"]?.personIdentifier.map((item)=>  {if(item.idType=="CM_NID"){
      setnidNumber(item?.personIdNumber)
      }})
    }else{
      setnidNumber(accountInformation["C1-Person"]?.personIdentifier?.personIdNumber)
    }
  }, [meterDetails?.accountPersonDetail?.accountPremiseDetailList,accountInformation]);

//bearer?.accountDetails?.accountSummary?.personAcccountDetail
  return (
    <>
    {showWarning ? (<EAccount_SA_Switched_Warning 
    heading="saId-home"
    openDialog={openDialog}
    sameDetails={sameDetails}
    updateDetails={updateDetails}
    />):null}

      <Grid container spacing={2}>
        <Grid item xs={6}>
        {
          customerLabelReady ? 
          <Typography variant="subtitle2">
            {labels ? labels("N_CUSTOMER_NO") : <Skeleton />}
          </Typography>
          : <Skeleton />
        }
          <Typography className={classes.blueTextColor} variant="subtitle1">
            {cNo ? (
             cNo
            ) : (
              <Skeleton />
            )}
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography variant="subtitle2">
            {profieLabelReady ? label("E_SERVICE_START_DATE") : <Skeleton />}
          </Typography>
          <Typography className={classes.blueTextColor} variant="subtitle1">
            {meterDetails?.getSaInfo?.saStartDate && dateFormat ? (
              moment(meterDetails?.getSaInfo?.saStartDate, "YYYY-MM-DD").format(
                dateFormat
              )
            ) : (
              <Skeleton />
            )}
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography variant="subtitle2">
            {profieLabelReady ? label("E_METER_SERIAL_NUMBER") : <Skeleton />}
          </Typography>
          <Typography className={classes.blueTextColor} variant="subtitle1">
            {meterSerialNumber  ? (
              meterSerialNumber 
            ) : (
              <Skeleton />
            )}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="subtitle2">
            {profieLabelReady ? label("E_SANCTIONED_LOAD") : <Skeleton />}
          </Typography>
          <Typography className={classes.blueTextColor} variant="subtitle1">
          {meterDetails?.getSaInfo?.load ? (
              Number(meterDetails?.getSaInfo?.load).toFixed(2)
            ) : (
              <Skeleton />
            )}{meterDetails?.getSaInfo?.load ? label("E_SANCTIONLOAD_UNIT") : <Skeleton />}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="subtitle2">
            {profieLabelReady ? label("E_SPOUSE_NAME") : <Skeleton />}
          </Typography>
          <Typography className={classes.blueTextColor} variant="subtitle1">
            {sName  ? (
              sName 
            ) : (
              <Skeleton />
            )}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="subtitle2">
            {profieLabelReady ? label("E_FATHER_NAME") : <Skeleton />}
          </Typography>
          <Typography className={classes.blueTextColor} variant="subtitle1">
          {fName? (
              fName
            ) : (
              <Skeleton />
            )}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle2">
            {profieLabelReady ? label("E_NOCS_OFFICE") : <Skeleton />}
          </Typography>
          <Typography className={classes.blueTextColor} variant="subtitle1">
          {noc? (
              noc
            ) : (
              <Skeleton />
            )}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle2">
            {profieLabelReady ? label("E_FEEDER_VALUE") : <Skeleton />}
          </Typography>
          <Typography className={classes.blueTextColor} variant="subtitle1">
          {tarrif ? (
             tarrif
            ) : (
              <Skeleton />
            )}
          </Typography>
        </Grid>
        {/* {meterDetails?.customerClassDesc ||
          meterDetails?.getSaInfo?.saTypeDesc ? (
            <Grid item xs={12}>
              <Typography variant="subtitle2">
                {profieLabelReady ? label("E_CUSTOMER_CLASS") : <Skeleton />}
              </Typography>
              <Typography className={classes.blueTextColor} variant="subtitle1">
                {meterDetails?.customerClassDesc &&
                meterDetails?.getSaInfo?.saTypeDesc ? (
                  meterDetails?.customerClassDesc +
                  ", " +
                  meterDetails?.getSaInfo?.saTypeDesc
                ) : meterDetails?.customerClassDesc ? (
                  meterDetails?.customerClassDesc
                ) : meterDetails?.getSaInfo?.saTypeDesc ? (
                  meterDetails?.getSaInfo?.saTypeDesc
                ) : (
                  <Skeleton />
                )}
              </Typography>
            </Grid>
           ):null}  */}

        {meterDetails?.getSaInfo?.saTypeDesc && profieLabelReady ? (
          <Grid item xs={12}>
            <Typography variant="subtitle2">
              {label("E_SERVICE_DESCRIPTION")}
            </Typography>
            <Typography className={classes.blueTextColor} variant="subtitle1">
              {meterDetails?.getSaInfo?.saTypeDesc +
                " (" +
                label(connectionStatus) +
                ")"}
            </Typography>
          </Grid>
        ) : (
          <Skeleton />
        )}
        <Grid item xs={12}>
          <Typography variant="subtitle2">
            {profieLabelReady ? label("E_PREMISE_DETAILS") : <Skeleton />}
          </Typography>
          <Typography className={classes.blueTextColor} variant="subtitle1">
            {premiseDetail ? premiseDetail : <Skeleton />}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}
